<template>
  <v-dialog max-width="500px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Product Trigger</span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6" md="6">
            <r-trigger-scope :items="scopes" :model.sync="model.scope"/>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <r-product-dropdown :model.sync="model.product" :clearable="true"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="6" sm="6">
            <v-text-field
              label="Key:"
              v-model.trim="model.key"
              v-ascii-only
            />
          </v-col>
          <v-col cols="12" sm="6" md="6" v-if="!model.product">
            <r-product-group-kind :model.sync="model.groups" :clearable="true" :multiple="true"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3" md="3">
            <v-btn v-if="!!model.search" @click="onSearch" small color="success"
                   class="my-4 fill-width">Search
            </v-btn>
            <v-btn v-else @click="onSearch" small outlined color="primary" class="my-4 fill-width">Search</v-btn>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-checkbox v-model="model.visible" label="Visible" class="mt-3" hide-details/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <r-search-dialog ref="r-search-dialog"/>
  </v-dialog>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {TriggerProduct, TriggerProductScope} from "@/modules/redactor/models/trigger/TriggerProduct";

import RTriggerScope from "@/modules/redactor/views/trigger/r-trigger-scope";
import RSearchDialog from "@/modules/redactor/views/search/r-search-dialog";
import RProductDropdown from "@/modules/redactor/views/product/r-product-dropdown.vue";
import RProductGroupKind from "@/modules/redactor/views/product-group/r-product-group-kind.vue";

export default {
  name: "r-trigger-product",
  components: {RProductGroupKind, RProductDropdown, RSearchDialog, RTriggerScope},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: VueTypes.objectOf(TriggerProduct),
    rules: ViewRules.READONLY,
  }),
  computed: {
    scopes() {
      return TriggerProductScope.getValues();
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new TriggerProduct();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onSearch() {
      let data = this.model.search ? this.model.search.clone() : null;
      this.$refs['r-search-dialog'].show(ViewRules.UPDATE, data).then(data => {
        this.model.search = data;
      }).catch(() => {
      });
    }
  }
}
</script>

<style lang="css" scoped>
.fill-width {
  width: 100%;
}
</style>